import http from './http';
// Reuse the News image upload + URL helpers (same GridFS-backed /api/file endpoint)
import { uploadImage, getImageUrl } from './newsService';

const create = (payload) => http.post('/announcement/add', payload);
const list = (page) => http.get(`/announcement/list?page_size=10&page_nbr=${page}`);
const load = (id) => http.get(`/announcement/load/${id}`);
const edit = (id, payload) => http.put(`/announcement/edit/${id}`, payload);
const remove = (id) => http.del(`/announcement/remove/${id}`);
const generate = (id) => http.post(`/announcement/${id}/generate`);
const updateDraft = (id, draftIndex, payload) =>
  http.put(`/announcement/${id}/draft/${draftIndex}`, payload);
const publishNews = (id, language) =>
  http.post(`/announcement/${id}/publish/news`, { language });
const publishWordPress = (id, language) =>
  http.post(`/announcement/${id}/publish/wordpress`, { language });
const publishZendesk = (id, language) =>
  http.post(`/announcement/${id}/publish/zendesk`, { language });
const publishFacebook = (id, language) =>
  http.post(`/announcement/${id}/publish/facebook`, { language });
const publishLinkedin = (id, language) =>
  http.post(`/announcement/${id}/publish/linkedin`, { language });
// Set (or clear, image=null) the per-language illustration image
const setImage = (id, language, image) =>
  http.put(`/announcement/${id}/image`, { language, image });

export default { create, list, load, edit, remove, generate, updateDraft, publishNews, publishWordPress, publishZendesk, publishFacebook, publishLinkedin, setImage, uploadImage, getImageUrl };
export { create, list, load, edit, remove, generate, updateDraft, publishNews, publishWordPress, publishZendesk, publishFacebook, publishLinkedin, setImage, uploadImage, getImageUrl };
